;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('FieldModificationController', FieldModificationController)

  FieldModificationController.$inject = ['$uibModalInstance', 'title', 'value']

  function FieldModificationController ($uibModalInstance, title, value) {
    var self = this

    self.$onInit = () => {
      init()
    }
    function init () {
      self.title = title
      self.value = value
    }

    function accept () {
      $uibModalInstance.close(self.value)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    _.extend(self, {
      cancel: cancel,
      accept: accept
    })
  }
})(window.angular, window._)
